import { configureStore as reduxConfigureStore } from '@reduxjs/toolkit';
import { setGlobalDevModeChecks } from 'reselect';

import appSettings from 'wanderu-config';

import rootReducer from '../reducers';

function stateSanitizer(state) {
    const namespace = 'DUCKS/CARRIERS';
    const slice = 'CARRIER_DATA';
    return state && state[namespace] && state[namespace][slice]
        ? {
            ...state,
            [namespace]: {
                ...state[namespace],
                [slice]: {
                    blahblah: true,
                },
            },
        }
        : state;
}

function configureStore(initialState = {}) {
    setGlobalDevModeChecks?.({
        inputStabilityCheck: 'never', // disabling because we're doing so much wrong that it's causing a serious slowdown
    });

    const store = reduxConfigureStore({
        devTools: shouldApplyDevTools()
            ? { stateSanitizer: stateSanitizer }
            : false,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware({
            immutableCheck: {
                ignoredPaths: [/^(?!.*i18n|variants).*/gm],
            },
        }),
        preloadedState: initialState,
        reducer: rootReducer,
    });

    store.inject = (asyncReducerMap) => {
        Object.entries(asyncReducerMap)
            .forEach(([reducerPath, reducer]) => {
                const newReducer = rootReducer.inject( // This is not the way to do this. We should be moving reducers off of this method of injecting as we convert to slices
                    { reducer, reducerPath },
                    { overrideExisting: true }
                );
                store.replaceReducer(newReducer);
            });
    };

    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('../reducers', () => store.replaceReducer(rootReducer));
    }

    return store;
}

function shouldApplyDevTools() {
    const { env } = appSettings;

    if (env.isProductionBuild) {
        return false;
    }

    if (!env.isClient) {
        return false;
    }

    // eslint-disable-next-line no-underscore-dangle
    return !!window.__REDUX_DEVTOOLS_EXTENSION__;
}

export default configureStore;
